import { EndpointWithoutRequest, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";
import { GetNewStudentSessionReportContextResponse } from "./Response";

export class GetNewStudentSessionReportContextEndpoint extends EndpointWithoutRequest<GetNewStudentSessionReportContextResponse> {
    constructor(studentId: string, sessionId?: string | null) {
        super();
        let path = AppUrls.Server.Student.StudentSessions.GetNewStudentSessionReportContext.replace(":studentId", studentId);
        if (sessionId) {
            path += `?sessionId=${sessionId}`;
        }
        this.verb(Http.Get);
        this.path(path);
    }

    public async HandleResponseAsync(response: GetNewStudentSessionReportContextResponse): Promise<GetNewStudentSessionReportContextResponse> {
        return response;
    }
}
